@if (model) {
  <div class="dialog admin-location-form-dialog">
    <div mat-dialog-title class="modal-header">
      <h1 class="modal-title">
        @if (!sectionsContainer?.rootObject?.has_authority) {
          <ng-container>
            @if (!!data?.id) {
              <span>
                {{data.headingEditExisting | translate: {currentName: model.name?.name || ''} }}
              </span>
            } @else if (!!data) {
              <span>
                {{data.headingCreateNew | translate: {parentName: (parentName | translate) || ''} }}
              </span>
            }
          </ng-container>
        }
        @else {
          <ng-container>
            <span>
              {{'TRANS__ADMIN_CONCEPT__VIEW' | translate:{conceptType: (data.objectType | translate), name: model.name?.name} }}
            </span>
          </ng-container>
        }
      </h1>

      <button
        type="button"
        mat-icon-button
        class="close"
        [tabindex]="-1"
        aria-label="close dialog"
        mat-dialog-close=""
      >
        <mat-icon>
          close
        </mat-icon>
      </button>
    </div>

    @if (sectionsContainer?.formGroup) {
      <form
        (ngSubmit)="handleSaveClicked()"
        [formGroup]="sectionsContainer.formGroup"
        class="inherit-border-color"
      >
        <div mat-dialog-content class="modal-body modal-body-edit-fields">
          <div class="modal-main-content">
            @if (!sectionsContainer?.rootObject?.has_authority) {
              <ng-container>
                @if (primeFields) {
                  <app-edit-fields
                    [sectionsContainer]="sectionsContainer"
                    [object]="sectionsContainer.rootObject"
                    [fields]="primeFields"
                  ></app-edit-fields>
                }
                @else {
                  <app-section-view-edit
                    [sectionsContainer]="sectionsContainer"
                  ></app-section-view-edit>
                }
              </ng-container>
            }
            @else {
              <app-object-view
                [sectionsContainer]="sectionsContainer"
              ></app-object-view>
            }
          </div>
        </div>

        <div mat-dialog-actions class="modal-footer">
          <div
            [matTooltip]="disabledReason"
            [matTooltipDisabled]="!disabled"
          >
            <button
              mat-flat-button
              class="bold"
              type="submit"
              color='accent'
              [disabled]="disabled"
            >
              {{ 'TRANS__ADMIN__LOCATION__MODAL__SAVE_BUTTON_LABEL' | translate }}
            </button>
          </div>
          <button
            mat-button
            color="accent"
            class="bold"
            type="button"
            (click)="dialogRef.close(false)"
          >
            {{ 'TRANS__ADMIN__LOCATION__MODAL__CANCEL_BUTTON_LABEL' | translate }}
          </button>

          @if (storeStatus.failed) {
            <div>
              {{storeStatus.message | translate}} {{storeStatus.serverMsg | translate}}
            </div>
          }
        </div>

        <span>
          &nbsp;&nbsp;&nbsp;&nbsp; ID: {{sectionsContainer?.rootObject?.artifact_id}}
        </span>
      </form>
    }
  </div>
}
